import { BaseApiModel } from './BaseApiModel';

export class LotStepReport extends BaseApiModel {
  public contractId: string;
  public internalAudit: { [date: string]: 'NUMBER' };
  public revision: { [date: string]: 'NUMBER' };
  public externalAudit: { [date: string]: 'NUMBER' };
  public waitReturn: { [date: string]: 'NUMBER' };
}
